// src/components/plan/Ledger.jsx
// Pooled inbox SP5 — the prototype's `dl.ledger` (proto plan/payment.html and
// confirm.html): label and amount rows, a ruled bold total, and a muted
// "then" row. Used by the payment page and the Plan started page.
import React from "react";
import { cn } from "../ui";

export default function Ledger({ rows }) {
  return (
    <dl className="tw-m-0 tw-grid">
      {rows.map(({ label, value, kind }) => (
        <div
          key={label}
          className={cn(
            "tw-flex tw-items-baseline tw-justify-between tw-gap-4 tw-py-2 tw-text-sm",
            kind === "total" &&
              "tw-border-0 tw-border-t tw-border-solid tw-border-divider tw-font-bold",
            kind === "then" && "tw-text-text-muted",
          )}
        >
          <dt>{label}</dt>
          <dd className="tw-m-0 tw-tabular-nums">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
